import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { style: {"height":"112px"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "fl mt3" }, "日付選択に戻る", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr10 mr4",
  style: {}
}, "質問を固定表示", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = {
  key: 2,
  class: "fr w40 mt10 pad10"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "fw600 fs14" }, "◯ｘもしくは下のカレンダーから選択してください", -1)
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = {
  key: 0,
  style: {"table-layout":"fixed"},
  class: "w100"
}
const _hoisted_15 = {
  key: 0,
  class: "mt30"
}
const _hoisted_16 = {
  class: /*#__PURE__*/_normalizeClass(`strongDarkGreyBg`)
}
const _hoisted_17 = { class: "text-right w100" }
const _hoisted_18 = { class: "fs11 fw600 mr20" }
const _hoisted_19 = {
  key: 0,
  style: {"table-layout":"fixed"},
  class: "w100"
}
const _hoisted_20 = { height: "80" }
const _hoisted_21 = { class: "centered w100 posRe" }
const _hoisted_22 = { class: "mc" }
const _hoisted_23 = {
  key: 0,
  class: "posAb",
  style: {"right":"8px","top":"40px"}
}
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  class: "posAb",
  style: {"right":"8px","top":"0"}
}
const _hoisted_26 = {
  key: 0,
  class: "dropdown-toggle fw600 fr centered fs12 noBorder",
  style: {"width":"35px","margin-right":"5%","margin-top":"-3px","background-color":"transparent","appearance":"none","padding":"0","outline":"none"}
}
const _hoisted_27 = ["src"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 fs12",
  style: {}
}, "一番左に移動", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["src"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 fs12 alertRed",
  style: {}
}, "調整ページを終了", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["src"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 fs12",
  style: {}
}, "役割を変更", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["src"]
const _hoisted_42 = {
  role: "button",
  class: "fl mt5 fs12 mr5",
  style: {}
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["src"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 fs12",
  style: {}
}, "仲介メニュー", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_50 = { class: "fs12 fw600" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_55 = { key: 1 }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["src"]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["src"]
const _hoisted_60 = { key: 2 }
const _hoisted_61 = {
  class: "text-left w100 ofs",
  style: {"padding":"0 5px 0 5px","height":"30px"}
}
const _hoisted_62 = { class: "fs11 fw600" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_QuestionsBoxModal = _resolveComponent("QuestionsBoxModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`timespanTitle ${_ctx.columnWidthClass || `w20`} centered fl`),
      style: _normalizeStyle({
                maxWidth: _ctx.isSP ? `350px` : ``,
            })
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.vrm.isFiltered)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "pointer fl",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args)))
            }, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_left.png`),
                width: "25",
                height: "25",
                class: "fl pointer"
              }, null, 8, _hoisted_3),
              _hoisted_4,
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        (_ctx.from != `schedule_view`)
          ? (_openBlock(), _createBlock(_component_Dropdown, {
              key: 1,
              ref: "dropdown",
              id: "votedRoomEditMenu",
              style: {"min-width":"100px"}
            }, {
              dropdown: _withCtx(() => [
                _createElementVNode("li", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showQuestions && _ctx.showQuestions(...args))),
                  class: "fs12 pointer fw600 pad5",
                  style: {"line-height":"40px","width":"160px"}
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/form_icon.png`),
                    width: "17",
                    height: "17",
                    class: "ml7 fl mt4 mr5",
                    style: {}
                  }, null, 8, _hoisted_7),
                  _hoisted_8,
                  _hoisted_9
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "dropdown-toggle fw600 fr centered fs12 noBorder",
                  style: {"width":"35px","margin-right":"5%","margin-top":"-3px","background-color":"transparent","appearance":"none","padding":"0","outline":"none"},
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickEditMenu && _ctx.clickEditMenu(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/line3.png`),
                    width: "30",
                    height: "30",
                    class: "fr pointer"
                  }, null, 8, _hoisted_6)
                ])
              ]),
              _: 1
            }, 512))
          : _createCommentVNode("", true),
        (_ctx.showMyVoteView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/ar_down.png`),
                width: "18"
              }, null, 8, _hoisted_12)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_13,
      (_ctx.Util.isPresent(_ctx.vrm.displayFields) && _ctx.from != `schedule_view`)
        ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
            (_ctx.canUseChukaiMenu)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vrm.displayFields, (_f, paramindex) => {
              return (_openBlock(), _createElementBlock("tr", {
                height: "30",
                key: `${_f.field_name}${paramindex}`
              }, [
                _createElementVNode("td", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_f.field_name), 1)
                  ])
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 6),
    _createElementVNode("div", {
      class: _normalizeClass(`availableTimeTable MembersHeader fl ${_ctx.cellWidthClass || `w80`} ofs noBar`),
      style: {"-ms-overflow-style":"none","scrollbar-width":"none"}
    }, [
      (_ctx.Util.isPresent(_ctx.vrm.suggestedMembers))
        ? (_openBlock(), _createElementBlock("table", _hoisted_19, [
            _createElementVNode("tr", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vrm.suggestedMembers, (mem, memindex) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: `${memindex}${mem.suggested_dates_display_type}${mem.suggested_dates_display_start_at}${mem.suggested_dates_display_end_at}${mem.suggested_dates_optional_schedules}${mem.systemUpdatedAt}${mem.name}${mem.private_memo}`,
                  class: _normalizeClass(`${memindex % 2 == 1 ? `yellowBg` : `llgreyBg`}`),
                  style: _normalizeStyle({
                            borderRadius: `18px 18px 0 0`,
                            width: _ctx.from == `schedule_view` ? `120px` : `220px`,
                        })
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      (mem.priorityType == `pinned`)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _withDirectives(_createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/pin_on.png`),
                              width: "30"
                            }, null, 8, _hoisted_24), [
                              [_directive_tooltip, `ピンしているため、確定後も残ります`]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_UserIcon, {
                        width: 42,
                        canEdit: false,
                        member: mem,
                        class: "fw600 fs20 mc mt10",
                        showTooltip: true
                      }, null, 8, ["member"])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_Dropdown, {
                        ref_for: true,
                        ref: "dropdown",
                        id: "votedRoomEditMenu",
                        style: {"min-width":"100px"}
                      }, {
                        dropdown: _withCtx(() => [
                          _createElementVNode("li", {
                            onClick: ($event: any) => (_ctx.goLeft(mem)),
                            class: "fs12 pointer fw600",
                            style: {"line-height":"20px","width":"160px","padding":"1px 5px"}
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/close_panel.png`),
                              width: "23",
                              height: "23",
                              class: "fl pointer mr5"
                            }, null, 8, _hoisted_29),
                            _hoisted_30,
                            _hoisted_31
                          ], 8, _hoisted_28),
                          _createElementVNode("li", {
                            onClick: ($event: any) => (_ctx.clickCloseRoom(mem)),
                            class: "fs12 pointer fw600",
                            style: {"line-height":"20px","width":"160px","padding":"1px 5px"}
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/status_ng.png`),
                              width: "17",
                              height: "17",
                              class: "fl mt4 mr10",
                              style: {}
                            }, null, 8, _hoisted_33),
                            _hoisted_34,
                            _hoisted_35
                          ], 8, _hoisted_32),
                          (_ctx.from != `schedule_view` && false)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 0,
                                class: "fs12 pointer fw600",
                                style: {"width":"160px","padding":"1px 5px"},
                                onClick: ($event: any) => (_ctx.changeMemberInfo(mem))
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/waaq_members.png`),
                                  width: "17",
                                  height: "15",
                                  class: "fl mr10 mt4",
                                  style: {}
                                }, null, 8, _hoisted_37),
                                _hoisted_38,
                                _hoisted_39
                              ], 8, _hoisted_36))
                            : _createCommentVNode("", true),
                          (_ctx.from != `schedule_view`)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 1,
                                class: "fs12 pointer fw600",
                                style: {"width":"160px","padding":"1px 5px"},
                                onClick: ($event: any) => (_ctx.changeCopyIfFix(mem))
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/pin_on.png`),
                                  width: "24",
                                  height: "22",
                                  class: "fl mr8 mt4",
                                  style: {"margin-left":"-4px"}
                                }, null, 8, _hoisted_41),
                                _createElementVNode("p", _hoisted_42, [
                                  (mem.priorityType == `pinned`)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, "ピンをはずす"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_44, "ピンする"))
                                ]),
                                _createVNode(_component_IconHelp, {
                                  width: 18,
                                  class: "fl mr5",
                                  tooltipText: `ピンすると、日程確定後も投票状況が残り、別の日程でも確定ができるようになります。\nまた公開ページの設定でピンした投票ページのみを公開することもできます。`,
                                  style: {"margin-top":"2px"}
                                }),
                                _hoisted_45
                              ], 8, _hoisted_40))
                            : _createCommentVNode("", true),
                          (_ctx.from != `schedule_view`)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 2,
                                class: "fs12 pointer fw600",
                                style: {"width":"160px","padding":"1px 5px"},
                                onClick: ($event: any) => (_ctx.openOtherMenuModal(mem))
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/waaq_members.png`),
                                  width: "17",
                                  height: "15",
                                  class: "fl mr10 mt4",
                                  style: {}
                                }, null, 8, _hoisted_47),
                                _hoisted_48,
                                _hoisted_49
                              ], 8, _hoisted_46))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          (_ctx.from != `schedule_view`)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_26, [
                                _createElementVNode("img", {
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/line3.png`),
                                  width: "30",
                                  height: "30",
                                  class: "fr pointer"
                                }, null, 8, _hoisted_27)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1536)
                    ]),
                    _createElementVNode("span", _hoisted_50, _toDisplayString(mem.name), 1),
                    (_ctx.from != `schedule_view` && _ctx.canUseChukaiMenu)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          (mem.suggested_dates_display_type != `all`)
                            ? _withDirectives((_openBlock(), _createElementBlock("label", {
                                key: 0,
                                class: "circle_button fw600 centered fs11 orangeAround",
                                style: {"width":"140px","padding":"4px 10px"},
                                onClick: ($event: any) => (_ctx.changeSuggestedDatesDisplayType(mem))
                              }, [
                                _createTextVNode("表示絞り込み設定中")
                              ], 8, _hoisted_52)), [
                                [_directive_tooltip, 
                                        `${mem.suggested_dates_display_type == `select_self` ? `個別選択` : `期間指定`}\n${
                                            mem.suggested_dates_display_type == `period`
                                                ? `${_ctx.DateTime.fromSeconds(mem.suggested_dates_display_start_at).toFormat(
                                                      `MM/dd`
                                                  )}~${_ctx.DateTime.fromSeconds(mem.suggested_dates_display_end_at).toFormat(
                                                      `MM/dd`
                                                  )}`
                                                : ``
                                        }`
                                    ]
                              ])
                            : (_openBlock(), _createElementBlock("label", {
                                key: 1,
                                class: "circle_button fw600 centered fs11 blueAround",
                                style: {"width":"140px","padding":"4px 10px"},
                                onClick: ($event: any) => (_ctx.changeSuggestedDatesDisplayType(mem))
                              }, " 絞り込みを設定 ", 8, _hoisted_53)),
                          _hoisted_54
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.from != `schedule_view`)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _withDirectives((_openBlock(), _createElementBlock("label", {
                            class: _normalizeClass(`fs12 pointer`),
                            style: {"padding":"4px 10px"},
                            onClick: ($event: any) => (_ctx.clickMember(mem))
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/pageicon.png`),
                              width: "13",
                              height: "13",
                              style: {"margin-top":"-2px"}
                            }, null, 8, _hoisted_57)
                          ], 8, _hoisted_56)), [
                            [_directive_tooltip, `調整ページへ`]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("label", {
                            class: _normalizeClass(`fs12 pointer`),
                            style: {"padding":"4px 10px"},
                            onClick: ($event: any) => (_ctx.clickFormMember(mem))
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/form_icon.png`),
                              width: "14",
                              height: "14",
                              style: {"margin-top":"-3px"}
                            }, null, 8, _hoisted_59)
                          ], 8, _hoisted_58)), [
                            [_directive_tooltip, `フォーム確認`]
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_60, " "))
                  ])
                ], 6))
              }), 128))
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayParamKeys, (paramKey, paramindex) => {
              return (_openBlock(), _createElementBlock("tr", {
                height: "38",
                key: `${paramKey}${paramindex}`
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vrm.suggestedMembers, (mem, memindex) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: `${memindex}${mem.id}`,
                    class: _normalizeClass(`${memindex % 2 == 1 ? `strongDarkGreyBg` : `dgreyBg `} hoverGreyBg`)
                  }, [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("span", _hoisted_62, _toDisplayString(mem.answer_results[paramKey] ? mem.answer_results[paramKey].value : `-`), 1)
                    ])
                  ], 2))
                }), 128))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _hoisted_63
    ], 2),
    _hoisted_64,
    _createVNode(_component_QuestionsBoxModal, { onUpdateQuestions: _ctx.updateQuestions }, null, 8, ["onUpdateQuestions"])
  ]))
}